import { Antwoord, ValidatieParameter } from '@models/claims';
import { ValidatieregelHelper } from '@services/public_api';

// @dynamic
export class IbanValidator {
  private static IbanNlRegexStr: string = '^NL\\d{2}[A-Z]{4}\\d{10}$';
  private static IbanBeRegexStr: string = '^BE\\d{2}\\d{3}\\d{9}$';
  private static IbanDeRegexStr: string = '^DE\\d{2}\\d{8}\\d{10}$';
  private static IbanRegex: RegExp = new RegExp(IbanValidator.IbanNlRegexStr + '|' + IbanValidator.IbanBeRegexStr + '|' + IbanValidator.IbanDeRegexStr);

  static ibanOpgemaakt: string;

  static isValidIban(antwoord: Antwoord, value: string) {
    if (antwoord == null) {
      return false;
    }

    if (value?.length > 0) {
      const ibanValidator: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'IBAN');
      if (ibanValidator != null) {
        if (!this.isGeldigIban(value)) {
          return false;
        }
      }
    }

    return true;
  }

  private static isGeldigIban(value: string): boolean {
    if (value == undefined)
      return false;

    // Remove dots and spaces
    value = value.replace(/([.\s])/g, '');

    return value.length > 9 &&
      value.length <= 34 &&
      this.validate97Proof(value.toUpperCase()) &&
      this.validateCountrySpecificIban(value.toUpperCase());
  }

  private static validate97Proof(value): boolean {
    if (!(/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(value))) {
      return false;
    }

    var ibanPrefix = value.substr(0, 4);
    var ibanRearranged = value.substr(4) + ibanPrefix;
    var ibanAsNumber = this.replaceChars(ibanRearranged);
    return this.mod97(ibanAsNumber) === 1;
  }

  private static replaceChars(val): string {
    var replaced = '';
    var char1, code;
    for (var i = 0, m = val.length; i < m; i++) {
      char1 = val.charAt(i);
      code = char1.charCodeAt(0);
      var j = code - 55;
      replaced += (code >= 65 && code <= 90) ? j.toString() : char1;
    }

    return replaced;
  }

  private static mod97(num): number {
    var mod = 0;
    var digit;
    for (var i = 0, m = num.length; i < m; i++) {
      digit = parseInt(num.charAt(i), 10);
      mod = ((mod * 10) + digit) % 97;
    }

    return mod;
  }

  private static validateCountrySpecificIban(value): boolean {
    return IbanValidator.IbanRegex.test(value);
  }
}
